var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isCarrierMarketplaceEnabled
    ? _c("div", [_c("OrderGridOverview")], 1)
    : _c(
        "div",
        { staticClass: "main-container" },
        [
          _c(
            "tabs",
            {
              staticClass: "custom-tab-list",
              attrs: {
                "tab-name": _vm.tabNames,
                "selected-panel": _vm.activeTab,
                "color-button": "success",
              },
              on: { "switch-panel": _vm.switchTab },
            },
            [
              _c(
                "template",
                { slot: "tab-pane-1" },
                [_c("OrderGridOverview")],
                1
              ),
              _c(
                "template",
                { slot: "tab-pane-2" },
                [
                  _c("OrdersDashboard", {
                    attrs: { "show-carrier-orders": true },
                  }),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }